var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rj-page-card"},[_c('div',{staticClass:"rj-page-card__content"},[_c('span',{style:(_vm.styleColor)},[_vm._v(" "+_vm._s(_vm.showMessage())+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }